module.exports = new __parcel__URL__("train_10_inactive.9e7957d7.png").toString();